import React from 'react';

import useConfiguratorData from '../../hooks/useConfiguratorData';
import useFinanciadoData from '../../hooks/useFinanciadoData';
import { CurrencyFormat } from '../../../utils';

const PrepaidMaintenancePlanSelector = () => {

    const { getPrepaidMaintenancePlans, getSelectedPrepaidMaintenancePlan, setSelectedPrepaidMaintenancePlan } = useConfiguratorData();
    const { resetFinanciado } = useFinanciadoData();

    const prepaidMaintenancePlans = getPrepaidMaintenancePlans();
    const selectedPrepaidMaintenancePlan = getSelectedPrepaidMaintenancePlan();

    const handleSelectPrepaid = (prepaid) => {
        setSelectedPrepaidMaintenancePlan(prepaid)
    }

    const handleOmitPrepaid = () => {
        setSelectedPrepaidMaintenancePlan(null);
        resetFinanciado();
    }

    return (
        <div className="prepaid-maintenance-plan-selector">
            {prepaidMaintenancePlans.length ? 
            <>
                <div className="component-header">
                    <h2>Mantenciones Prepagadas</h2>
                    <div className="component-subtitle">Incluye las mantenciones para mayor conveniencia y comodidad</div>
                </div>
                <div className="component-body">
                    {prepaidMaintenancePlans.map(prepaidMaintenance => (
                        <div 
                            className={"item-box " + (prepaidMaintenance === selectedPrepaidMaintenancePlan ? 'active' : '')} 
                            key={`prepaid-${prepaidMaintenance.id}`} 
                            onClick={() => handleSelectPrepaid(prepaidMaintenance)
                        }>
                            <div className="prepaid-maintenance">
                                <span className="name">{prepaidMaintenance.name}</span>
                                <span className="price">{CurrencyFormat(prepaidMaintenance.price)}</span>
                            </div>
                            {prepaidMaintenance.save_price ? 
                                <span className="save-price">Ahorra {CurrencyFormat(prepaidMaintenance.save_price)}</span>
                            : null}
                        </div>
                    ))}
                    <div className={"item-box " + (!selectedPrepaidMaintenancePlan ? 'active' : '')} onClick={() => handleOmitPrepaid()}>
                        <span>Omitir por ahora</span>
                    </div>
                </div>
            </>
            : null}
        </div>
    )
}

export default PrepaidMaintenancePlanSelector;